<template>
  <div class="no-data">
    <p>{{ msg }}</p>
  </div>
</template>

<script>
export default {
  name: 'NoData',
  props: {
    msg: {
      type: [String, Number],
      default: 'No data to display yet',
    },
  },
}
</script>

<style lang="scss" scoped>
.no-data {
  max-height: 100px;
  display: flex;
  justify-content: center;
}
</style>
